<template>

  <div class="my-3">
    <b-row>
      <b-form-checkbox 
        switch 
        v-model="fuma.active"
        class="col-2 ml-1"
      >
        Fuma
      </b-form-checkbox>

      <b-col v-if="fuma.active">
        <div>
          <b-row class="">
            <div class="offset-1 col-6">Edad en que empezo a fumar: </div>
            <b-form-input 
              v-model="fuma.edadFuma" 
              type="number" 
              class="col-2"
              size="sm"
            />
          </b-row>

          <b-row class="my-1">
            <div class="offset-1 col-6">Cantidad de cigarrillos al dia: </div>
            <b-form-input 
              v-model="fuma.nCigarrillos" 
              type="number" 
              class="col-2"
              size="sm"
            />
          </b-row>

          <b-row>
            <div class="offset-1 col-6">
              <b-form-checkbox v-model="fuma.dejoFumar">
                Edad que dejo de fumar:
              </b-form-checkbox>
            </div>
          
            <b-form-input
              v-if="fuma.dejoFumar"
              v-model="fuma.edadDejoFumar" 
              type="number" 
              class="col-2"
              size="sm"
            />

            <span v-if="!fuma.dejoFumar" class="text-danger">Actualmente fuma</span>

            <span 
              v-if="fuma.dejoFumar && (fuma.edadDejoFumar < fuma.edadFuma)" 
              class="text-danger"
            >
              No puede ser menor a la edad que empezo a fumar
            </span>

            <span 
              v-if="fuma.dejoFumar && (fuma.edadDejoFumar > edadActual)" 
              class="text-danger"
            >
              No puede ser mayor a la edad actual
            </span>

          </b-row>

          <b-row class="my-1">
            <b-col class="offset-1">
              <b-progress 
                :value="scoreRiesgo"
                :max="10" 
                :variant="colorBarTotal"
                striped
                show-value
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
  
</template>

<script>
import { mapState } from 'vuex';
import { calculateAgeWithDateString } from '@/shared/helpers';

export default {

  name: "InfoFuma",

  data() {
    return {

      fuma:{
        active:false,
        edadFuma:0,
        nCigarrillos:0,
        dejoFumar:false,
        edadDejoFumar:0,
        aniosFuma:0
      },

      edadActual:0,
      scoreRiesgo: 0,
      colorBarTotal:'success',
    }
  },

  created() {
  },


  methods: {
    onCalculateRiesgo(){
      this.onCalculateAniosFuma();
      this.scoreRiesgo = (this.fuma.nCigarrillos * this.fuma.aniosFuma) / 20;
      this.colorBarTotal = this.scoreRiesgo < 4 
        ? 'success' 
        : this.scoreRiesgo < 6
          ? 'info'
          : this.scoreRiesgo < 10
            ? 'warning'
            : 'danger';
    },


    onCalculateAniosFuma(){

      this.fuma.edadDejoFumar = this.fuma.dejoFumar 
        ? this.fuma.edadDejoFumar
        : this.edadActual;

      this.fuma.aniosFuma = this.fuma.edadDejoFumar - this.fuma.edadFuma;
    },

    onDataAtencionMedica(){
      if( !this.dataAtencionMedica ) return;
      const { fechaNacimiento } = this.dataAtencionMedica.paciente.persona;
      this.edadActual = calculateAgeWithDateString( fechaNacimiento );
    }

  },


  computed: {
    ...mapState({
      dataAtencionMedica: state => state.atencionCita.dataCita
    }),
  },

  watch: {
    dataAtencionMedica:{
      handler: 'onDataAtencionMedica',
      deep: true,
    },

    fuma:{
      deep: true,
      handler(newValue){
        this.onCalculateRiesgo();

        this.$store.commit("setNeumologica", { fuma:newValue } );
      },
    },

  }
}
</script>

